/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


class Batch
{
  constructor (id)
  {
    this.id = id;
    this.ready = false;

    this.notifications = [];
  }


  push (routing, data)
  {
    this.notifications.push({ routing, data });
  }


  commit ()
  {
    this.ready = true;
  }


  isReady ()
  {
    return this.ready;
  }


};


export default class Batches
{
  constructor ()
  {
    this.queue = [];
    this.batches = new Map();
  }


  create (id)
  {
    const batch = new Batch(id);

    this.queue.push(batch);
    this.batches.set(id, batch);
  }


  push (id, routing, data)
  {
    this.batches.get(id).push(routing, data);
  }


  commit (id)
  {
    this.batches.get(id).commit();

    let result = [];

    while (this.queue.length && this.queue[0].isReady())
    {
      const batch = this.queue.shift();

      this.batches.delete(batch.id);

      result.push(batch.notifications);
    }

    return result;
  }


};
